import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

type Props = {
  open: boolean;
  boardName: string;
  onClose: () => void;
  onConfirm: () => void;
};

export default function ConfirmDeleteDialog({
  open,
  boardName,
  onClose,
  onConfirm,
}: Props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile = fullScreen;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      fullScreen={fullScreen}
    >
      <DialogTitle>Delete Board</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to permanently delete Board: <b>{boardName}</b>?
        </Typography>
      </DialogContent>
      <DialogActions
        sx={
          isMobile && {
            pt: 1,
            px: 2,
            pb: 2,
            gap: 1,
            alignItems: 'stretch',
            flexDirection: 'column',
          }
        }
      >
        <Button
          onClick={onClose}
          color="inherit"
          sx={
            isMobile && {
              py: 2,
              fontSize: 18,
              width: '100%',
            }
          }
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          sx={
            isMobile && {
              py: 2,
              fontSize: 18,
              width: '100%',
            }
          }
        >
          Yes, Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
